import { render, staticRenderFns } from "./ClientAreaInput.vue?vue&type=template&id=a9618b2a&"
import script from "./ClientAreaInput.vue?vue&type=script&lang=js&"
export * from "./ClientAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientAreaInput.vue"
export default component.exports